module.exports = [{
      plugin: require('/Users/designlens/Documents/designLense Studio th/packages/landing-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
